
import Vue from 'ninenine-white-label/Vue'
import Vuex from 'vuex'

import opportunities from 'ninenine-white-label/store/modules/opportunities'
import location from 'ninenine-white-label/store/modules/location'
import user from 'ninenine-white-label/store/modules/user'
import domains from 'ninenine-white-label/store/modules/domains'
import graphql_queries from 'ninenine-white-label/store/modules/graphql_queries'
import tests from 'ninenine-white-label/store/modules/tests'
import { state } from '@/views/home/store/state.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    opportunities,
    location,
    user,
    domains,
    graphql_queries,
    tests
  },

  state: {
    ...state,
    source: 'carreiras',
    companyId: process.env.NODE_ENV == 'development' ? 5004 : 6327,
    tkn: `Token token=${process.env.VUE_APP_API_TOKEN}`,
    deviseForm: null,
    deviseLoading: false,
    deviseTrying: {},
    personalDataForm: {},
    educationsForms: [],
    professionalExperiencesForms: [],
    languagesForms: [],
    flag_no_professional_experience: false,
    opportunityQuestionsForm: {},
    indicationForm: {},
    levels: [
      { "id": 1, "name": "Jovem Aprendiz" },
      { "id": 3, "name": "Estágio" },
      { "id": 4, "name": "Trainee" },
      { "id": 8, "name": "Assistente" },
      { "id": 10, "name": "Júnior" },
      { "id": 11, "name": "Pleno" },
      { "id": 12, "name": "Sênior" },
      { "id": 13, "name": "Coordenador" },
      { "id": 14, "name": "Especialista" },
      { "id": 15, "name": "Gerente" },
      { "id": 17, "name": "Diretor" }
    ],
    teams: [
      {
        thumb: 'teams/operacoes/operacoes-thumb.jpg', cover: 'teams/operacoes/operacoes-cover.jpg', title: 'Operações', short_content: '<p>Diretoria responsável pelo gerenciamento matricial dos shoppings, definindo diretrizes, processos e dando suporte técnico necessário ao melhor desempenho operacional, além de atuar no planejamento e execução de projetos de obras e retrofit.</p>', content: `
      <p>A <strong class="text-blue-br">Diretoria Executiva de Operações</strong> é responsável pelo gerenciamento matricial dos shoppings, definindo diretrizes, processos e dando suporte técnico necessário para o melhor desempenho operacional, além de atuar no planejamento e execução de projetos de obras e retrofit. <br> Suas áreas matriciais são: Comercial, Operações, Marketing e Mídia e Desenvolvimento. Além das áreas matriciais, também temos as administrações de shoppings responsáveis pelo gerenciamento do empreendimento na ponta.</p>

      <p>Conheça mais sobre as áreas:</p>

      <h4 class="text-blue-br">Áreas Matriciais</h4>
      <ul class="ul-br">
        <li>A área <strong>Comercial e de Jornada do Lojista</strong> tem o objetivo de maximizar o crescimento orgânico de curto e longo prazo da companhia através das alavancas comerciais, gestão de mix de lojas e resultados dos nossos shoppings. Trabalha em prol do melhor atendimento aos nossos lojistas e o relacionamento com os nossos parceiros;</li>
        <li>A área de <strong>Operações dos shoppings e de Jornada do Ativo</strong> é responsável pelo gerenciamento da operação dos shoppings, como: garantir a correta depreciação dos ativos e equipamentos, gerenciar o consumo de utilidades, garantir processos e políticas para segurança e prevenção de incêndio, regularização imobiliária dos ativos em operação e gerir NOI Estacionamento. Seu objetivo principal é gerar eficiência e melhoria de qualidade em todas as disciplinas envolvidas;</li>
        <li>A área de <strong>Marketing e de Jornada do Consumidor</strong> é responsável por identificar tendências dos consumidores para assim tomar decisão e desenhar as estratégias que serão aplicadas nos nossos shoppings. Tem como diferencial a experiência e entretenimento para multi família nos nossos empreendimentos;</li>
        <li>A área de <strong>Mídia</strong> é especializada em comercializar mídia nos nossos shoppings center. O time identifica as melhores negociações de mídia com as marcas para definir os melhores planos de comunicação;</li>
        <li>A área de <strong>Desenvolvimento</strong> é responsável por projetos, como: expansão, greenfields, retrofits e densification, realizando todo o planejamento e execução das obras.</li>
      </ul>

      <h4 class="text-blue-br">Shopping Center</h4>
      <p>Onde a magia acontece! As administrações são responsáveis pelo gerenciamento dos empreendimentos, colocando em prática todas as iniciativas que tornam os nossos shoppings os melhores destinos de felicidade para os nossos clientes. Sua atuação é dividida em 3 áreas:</p>
      <ul class="ul-br">
        <li><strong>Comercial/Comercialização</strong></li>
        <li><strong>Operações</strong></li>
        <li><strong>Marketing</strong></li>
      </ul>
      `, gallery: [
          { src: 'teams/operacoes/1.jpg', thumb: 'teams/operacoes/1.jpg' },
        ]
      },

      {
        thumb: 'teams/gente-e-gestao/gente-e-gestao-thumb.jpg', cover: 'teams/gente-e-gestao/gente-e-gestao-cover.jpg', title: 'Gente & Gestão', short_content: '<p>Diretoria responsável por transmitir e consolidar valores smartfit, bem como levar a nossa cultura de Gestão a todas as áreas da Cia.</p>', content: `
      <p>A <strong class="text-blue-br">Diretoria Executiva de Gente & Gestão</strong> é responsável por promover e consolidar a cultura e valores da smartfit para todos os colaboradores através das diretrizes e incentivos adequados. Sua estrutura é dividida em:</p>

      <h4 class="text-blue-br">Atração, Aprendizagem e Desenvolvimento</h4>
      <ul class="ul-br">
        <li><strong>Atração</strong> (Produto e Recrutamento & Seleção)</li>
        <li><strong>Desenvolvimento</strong> (Treinamento/Capacitação), <strong>Carreira e Sucessão</strong></li>
      </ul>

      <h4 class="text-blue-br">Business Partner</h4>
      <ul class="ul-br">
        <li><strong>Designer de Soluções</strong> para as unidades de Negócio relacionadas a Estratégia, Cultura e experiência do colaborador.</li>
      </ul>

      <h4 class="text-blue-br">Cultura, Comunicação e Time Ágil</h4>
      <ul class="ul-br">
        <li><strong>Cultura e Diversidade</strong></li>
        <li><strong>Comunicação</strong></li>
        <li><strong>Time Ágil</strong></li>
      </ul>

      <h4 class="text-blue-br">Performance e Recompensa</h4>
      <ul class="ul-br">
        <li><strong>Performance</strong> (Gestão de Metas e Avaliação de Desempenho)</li>
        <li><strong>Recompensa</strong> (Estratégia de Remuneração e ILP)</li>
      </ul>

      <h4 class="text-blue-br">Jornada do Colaborador</h4>
      <ul class="ul-br">
        <li><strong>DP, SSO, RT, Benefícios</strong></li>
        <li><strong>Infogente</strong></li>
      </ul>

      `, gallery: [
          { src: 'teams/gente-e-gestao/1.jpg', thumb: 'teams/gente-e-gestao/1.jpg' },
        ]
      },

      {
        thumb: 'teams/financeiro/financeiro-thumb.jpg', cover: 'teams/financeiro/financeiro-cover.jpg', title: 'Financeira', short_content: '<p>Diretoria responsável pelo planejamento financeiro, organização e controle das finanças da Cia.  Também é responsável pela gestão dos processos transacionais e administração dos riscos financeiros da smartfit.</p>', content: `
        <p>A <strong class="text-blue-br">Diretoria Executiva Financeira</strong> é responsável pelo planejamento financeiro, organização e controle das finanças da Cia.  Também é responsável pela gestão dos processos transacionais e administração dos riscos financeiros da smartfit.</p>

        <p>Conheça mais sobre as áreas:</p>

        <ul class="ul-br">
          <li><strong>Financeiro Corporativo:</strong> diretoria responsável por Relação com Investidores, Planejamento e Orçamento, Análise de Investimentos, Cash & Funding, Suprimentos e M&A;</li>
          <li><strong>Controladoria e Contábil/Fiscal:</strong> diretoria responsável pela organização, avaliação, armazenamento de informações e demonstrações financeiras da smartfit. Também é responsável pelas informações econômicas financeiras para tomadas de decisão;</li>
          <li><strong>Backoffice:</strong> é nossa central de serviços compartilhados, onde centralizamos todos os processos financeiros da companhia, de pagamento a gestão de caixa, do cadastro de contratos e clientes até a gestão contas a receber e análise e reporte de relatórios e indicadores, visando ganho em escala, controle e suporte às áreas de negócio na geração de valor.</li>
        </ul>

      `, gallery: [
          { src: 'teams/financeiro/1.jpg', thumb: 'teams/financeiro/1.jpg' },
        ]
      },


      {
        thumb: 'teams/juridico/juridico-thumb.jpg', cover: 'teams/juridico/juridico-cover.jpg', title: 'Jurídico', short_content: '<p>Diretoria responsável pela gestão jurídica e legal de todos os ativos da Cia. O escopo principal inclui regularizações, gestão de contratos, mapeamento de riscos.</p>', content: `
        <p>A Diretoria Executiva do Jurídico é responsável pela prevenção e controle mitigando riscos para Cia. Também participa ativamente na conclusão das operações financeiras M&A, Novos Negócios e Desenvolvimento de novos shoppings.</p>

        <p>Na operação dos empreendimentos, define diretrizes, estratégias, garantindo legalidade e regularidade dos Shoppings, trabalhando de forma colaborativa com as equipes de operações, além realizar a gestão de parceiros jurídicos, gerenciando nosso passivo.</p>

        <p>A diretoria se divide em 5 principais frentes:</p>

        <ul class="ul-br">
          <li><strong>Atendimento Matricial</strong></li>
          <li><strong>Atendimento aos Shoppings</strong></li>
          <li><strong>Gestão de Ativos</strong></li>
          <li><strong>Compliance</strong></li>
          <li><strong>Auditoria Interna</strong></li>
        </ul>

      `, gallery: [
          { src: 'teams/juridico/1.jpg', thumb: 'teams/juridico/1.jpg' },
        ]
      },

      {
        thumb: 'teams/transformacao-digital/transformacao-digital-thumb.jpg', cover: 'teams/transformacao-digital/transformacao-digital-cover.jpg', title: 'Estratégia e Tecnologia', short_content: '<p>Diretoria responsável por posicionar smartfit como agente catalisador de inovação para nossos clientes.</p>', content: `
        <p>A <strong class="text-blue-br">Diretoria Executiva de Estratégia e Tecnologia</strong> é
        responsável por posicionar a companhia como agente catalisador de inovação para os
        nossos clientes, conectando as soluções do ecossistema e buscando startups que
        possam acelerar a implementação do planejamento estratégico da smartfit.</p>

        <p>São responsáveis por elaborar as estratégias de transformação digital levando em
        consideração o impacto nos negócios e nos clientes. ​Além disso, buscam orientar o
        desenvolvimento do roadmap digital através da implementação dos modelos, métodos
        e rituais necessários para o método ágil de trabalho.</p>

        <p>A diretoria se divide em 6 principais frentes:</p>

        <ul class="ul-br">
          <li><strong>Planejamento Estratégico</strong></li>
          <li><strong>Transformação Digital (Desenvolvimento de softwares)</strong></li>
          <li><strong>TI, Arquitetura e Suporte</strong></li>
          <li><strong>Negócios Adjacentes</strong></li>
          <li><strong>Corporate Venture Capital</strong></li>
          <li><strong>Squad de Dados</strong></li>
        </ul>

      `, gallery: [
          { src: 'teams/transformacao-digital/1.jpg', thumb: 'teams/transformacao-digital/1.jpg' },
        ]
      },

    ],

    values: [
      { title: 'Cliente', icon: 'values/cliente.png', content: 'Temos o compromisso de servir todos nossos clientes com empatia e integridade.' },
      { title: 'Dono', icon: 'values/dono.png', content: 'Somos um time apaixonado pelo nosso negócio e trabalhamos com autonomia, simplicidade e espírito empreendedor.' },
      { title: 'Colaboração', icon: 'values/colaboracao.png', content: 'Somos abertos a ouvir e entender nossos clientes, colaboradores e parceiros, estimulando a integração e a confiança entre todos.' },
      { title: 'Time Excelente', icon: 'values/time.png', content: 'Valorizamos a excelência e a dedicação, reconhecendo, via meritocracia, a importância de cada um na construção de nosso sucesso.' },
      { title: 'Resultados hoje e sempre', icon: 'values/resultados.png', content: 'Trabalhamos pelo presente e pelo longo prazo do nosso negócio, obstinados por resultados sustentáveis que constroem nosso legado.' },
    ],

    conquistas: [
      { title: 'Linkedin', image: 'logo-top-companies.jpg', content: '21º lugar em "Top Companies: as 25 empresas onde os brasileiros sonham trabalhar"', year: '2019' },
      { title: 'Linkedin', image: 'logo-finalist.jpg', content: 'A smartfit foi finalista em uma categoria do LinkedIn Talent Awards: a Best Talent Acquisition Team!', year: '2018' },
      { title: 'Linkedin', image: 'logo-top-companies.jpg', content: '15º lugar em "Top Companies: as 25 empresas onde os brasileiros sonham trabalhar"', year: '2017' },
      { title: 'Love Mondays', image: 'logo-lovemondays.jpg', content: '46º lugar em "50 empresas mais amadas pelos seus colaboradores no Brasil"', year: '2017' },
      { title: 'Linkedin', image: 'logo-linkedin.jpg', content: '17º lugar em “As empresas mais atraentes onde os brasileiros sonham trabalhar”', year: '2016' },
    ],

    faqItems: [
      { title: `Onde ficam os locais de trabalho?`, content: `Além das mais de 900 unidades espalhadas pelo Brasil, nós temos escritório em São Paulo.` },

      {
        title: `Moro em outro estado. Posso me inscrever para as vagas?`, content: `Caso você esteja se candidatando para uma oportunidade na nossa área de tecnologia, você poderá optar pelo full remoto (caso a vaga permita este formato) ou modelo híbrido (home office e presencial).
      Nas demais áreas, você também pode se inscrever, mas é necessário estar disponível para mudança de estado ou cidade.` },

      { title: `Como funciona o processo de seleção de vocês?`, content: `Algumas de nossas vagas funcionam como banco de talentos. Nesse caso, basta você se candidatar e já estará disponível para as próximas etapas do processo seletivo. Outras vagas surgem pontualmente, então fique atento às vagas das nossas marcas.` },

      { title: `Existem vagas para quem está ingressando no mercado?`, content: `Sim! Temos oportunidade que são portas de entrada importantes para quem está começando a carreira!` },

      { title: `Tem vagas abertas para pessoas com deficiência?`, content: `Sim! Todas as nossas vagas são abertas para pessoas com deficiência. Estamos esperando por você!` },

      {
        title: `Não encontrei nenhuma vaga com o meu perfil. Posso deixar meu currículo?`, content: `Sim, você pode! Que tal já fazer isso agora?  <a href="/deixe-seu-perfil" >Clique aqui!</a> para cadastrar seu currículo no nosso banco de talentos!`
      },
      { title: `Quais são os canais oficiais de divulgação de vagas?`, content: `Nós só divulgamos vagas do Grupo Smart Fit nestes canais: 99Jobs, Indeed, LinkedIn, Facebook Jobs, Google Jobs, Glassdoor e Egalitê.` },
      {
        title: `Existe alguma taxa de inscrição?`, content: `A gente não cobra nenhuma taxa de inscrição.`
      },

    ],

  },

  getters: {
    basicProfileEmpty: state => {
      const profile = state.user.profile || {};

      return (
        !profile.nationality || profile.nationality.length == 0 ||
        (
          (!profile.cpf || profile.cpf.length == 0) &&
          (!profile.passport || profile.passport.length == 0)
        ) ||
        !profile.phone || profile.phone.length == 0 ||
        !profile.birthday || profile.birthday.length == 0 ||
        !profile.gender || profile.gender.length == 0 ||
        !profile.location.zipcode || profile.location.zipcode.length == 0 ||
        !profile.location.street || profile.location.street.length == 0 ||
        !profile.location.number || profile.location.number.length == 0 ||
        !profile.location.neighborhood || profile.location.neighborhood.length == 0 ||
        !profile.location.city || profile.location.city.length == 0 ||
        !profile.location.stateId || profile.location.stateId.toString().length == 0
      ) &&
        (!profile.educations || profile.educations.length == 0) &&
        (!profile.professionalExperiences || profile.professionalExperiences.length == 0 || state.flag_no_professional_experience == false)
    }
  },

  mutations: {
    CHANGE_TKN(state, payload) {
    },

    DEVISE_FORM(state, payload) {
      state.deviseForm = payload;
    },

    DEVISE_LOADING(state, payload) {
      state.deviseLoading = payload;
    },

    DEVISE_TRYING(state, payload) {
      state.deviseTrying = payload == null ? {} : payload;
    },

    PERSONAL_DATA_FORM(state, payload) {
      state.personalDataForm = payload;
    },

    EDUCATIONS_FORMS(state, payload) {
      if (!payload) {
        state.educationsForms = []
      } else {
        if (state.educationsForms.find(form => form._uid == payload._uid)) {
          state.educationsForms[state.educationsForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.educationsForms.push(payload);
        }
      }
    },

    PROFESSIONAL_EXPERIENCES_FORMS(state, payload) {
      if (!payload) {
        state.professionalExperiencesForms = []
      } else {
        if (state.professionalExperiencesForms.find(form => form._uid == payload._uid)) {
          state.professionalExperiencesForms[state.professionalExperiencesForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.professionalExperiencesForms.push(payload);
        }
      }
    },

    LANGUAGES_FORMS(state, payload) {
      if (!payload) {
        state.languagesForms = []
      } else {
        if (state.languagesForms.find(form => form._uid == payload._uid)) {
          state.languagesForms[state.languagesForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.languagesForms.push(payload);
        }
      }
    },

    SET_FLAG_PROFESSIONAL_EXPERIENCE(state, payload) {
      state.flag_no_professional_experience = payload
    },

    OPPORTUNITY_QUESTIONS_FORM(state, payload) {
      state.opportunityQuestionsForm = payload
      localStorage.setItem('opportunity_questions', JSON.stringify(payload))
    },

    INDICATION_FORM(state, payload) {
      state.indicationForm = payload
      localStorage.setItem('indication_form', JSON.stringify(payload))
    }
  }

});